
import React from 'react';
import { IconButton, Typography } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { toast } from "react-hot-toast";

interface CopyableProps {
    text: string;
    label?: string | React.ReactNode;
}

const Copyable: React.FC<CopyableProps> = ({ text, label }) => {
    const handleCopy = () => {
        navigator.clipboard.writeText(text).then(() => {
            toast.success("Copied to clipboard!");
        });
    };

    return (
        <Typography component="span" sx={{ display: 'flex', alignItems: 'center', gap: '5px', fontWeight: 'inherit', fontSize: 'inherit' }}>
            {label || text}
            <IconButton onClick={handleCopy} size="small" sx={{ color: 'gray' }}>
                <ContentCopyIcon fontSize="small" />
            </IconButton>
        </Typography>
    );
};

export default Copyable;